import React, { useState, useEffect } from "react";
import { ThemeContext, themes } from "contexts/ThemeContext";

export default function ThemeContextWrapper(props) {
  // Cargar tema guardado de localStorage o usar el tema oscuro por defecto
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('maecore-theme');
    return savedTheme || themes.dark;
  });

  function changeTheme(theme) {
    setTheme(theme);
    // Guardar tema en localStorage para que persista entre sesiones
    localStorage.setItem('maecore-theme', theme);
  }

  useEffect(() => {
    switch (theme) {
      case themes.light:
        document.body.classList.add("white-content");
        break;
      case themes.dark:
      default:
        document.body.classList.remove("white-content");
        break;
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme: theme, changeTheme: changeTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
}
